'use strict';

/*global app*/
/*global services*/
/*global isEmpty*/
/*global invokeCallback*/
/*global initialize*/
/*global parseFloatK2*/
/*global formatFloatK2*/

function BasicItemForm(formClass) {
  this.confirm = null;
  this.formClass = formClass;
  this.modalClass = 'item-form ' + formClass;

  this.$container = null;

  this.defaultSettings = null;
  this.settings = null;

  this.locationService = null;
  this.handlingUnitService = null;
  this.inputService = null;

  this.data = null;
  this.origData = null;

  this.onScreenMessages = [];

  this.initBasic();
}

BasicItemForm.prototype = $.extend({}, {
  constructor: 'BasicItemForm',

  registerCallbacksBasic: function registerCallbacksBasic() {
    var _this = this;

    $('body').on('click', '.' + _this.formClass + ' .item-form__product-info', function () {
      _this.viewProductInfo();

      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  getFormField: function getFormField(name) {
    var _this = this;
    return _this.$container.find('[name*="[' + name + ']"]');
  },

  getFormValue: function getFormValue(name) {
    var _this = this;
    return $.trim(_this.getFormField(name).val());
  },

  getFormFloatValue: function getFormFloatValue(name) {
    var _this = this;

    var value = _this.getFormValue(name);
    return parseFloatK2(value);
  },

  setFormValue: function setFormValue(name, value) {
    var _this = this;
    _this.$container.find('[name*="[' + name + ']"]').val(value);
  },

  setFormFloatValue: function setFormFloatValue(name, value) {
    var _this = this;

    value = formatFloatK2(value);
    _this.setFormValue(name, value);
  },

  getFormBoolValue: function getFormBoolValue(name) {
    var _this = this;

    var value = _this.getFormValue(name);
    return value === '1';
  },

  setFormBoolValue: function setFormBoolValue(name, value) {
    var _this = this;

    value = value ? '1' : '0';
    _this.setFormValue(name, value);
  },

  getWebDocumentRID: function getWebDocumentRID() {
    var _this = this;

    return _this.getFormValue('WebDocumentRID');
  },

  getWebDocumentItemRID: function getWebDocumentItemRID() {
    var _this = this;

    return _this.getFormValue('WebDocumentItemRID');
  },

  //----------------------------------------------------------------------------

  viewProductInfo: function viewProductInfo() {
    var _this = this;

    //u procesu prijmu prijimam na sklad prijmu - mel bych spatne informace, musim tedy poslat 0 a z nastaveni se precte hlavni sklad

    var areaId = 0;
    if (parseInt(_this.data.ToLocationAreaId)) {
      areaId = _this.data.ToLocationAreaId;
    } else if (_this.data.AreaId) {
      areaId = _this.data.AreaId;
    }

    var data = {
      StockId: _this.settings.isReceiptProcess ? _this.data.MainWarehouseId : _this.data.StockId,
      ArticleAbbr: _this.data.ArticleAbbr,
      AreaId: areaId,
    };

    services.get('product-info').viewProductInfo(data);

    return _this;
  },

  //----------------------------------------------------------------------------

  initFormBasic: function initFormBasic(data) {
    var _this = this;

    _this.confirm.content(data.html);

    initialize(_this.confirm.contentDOM());

    _this.data = data;
    _this.$container = _this.confirm.contentDOM();

    return _this;
  },

  //----------------------------------------------------------------------------

  isFormValid: function isFormValid() {
    //nutne prepsat v potomkovi
    return true;
  },

  doSave: function doSave() {
    var _this = this;

    //nutne prepsat v potomkovi

    return _this;
  },

  save: function save() {
    var _this = this;

    if (_this.isFormValid()) {
      _this.doSave();
    }

    return _this;
  },

  cancel: function () {
    var _this = this;

    _this.close();

    return _this;
  },

  close: function close() {
    var _this = this;

    _this.confirm.close();

    return _this;
  },

  open: function open() {
    var _this = this;

    //nutne prepsat v potomkovi

    return _this;
  },

  doViewOnScreenMessages: function doViewOnScreenMessages(callback) {
    var _this = this;

    if (_this.onScreenMessages.length === 0) {
      invokeCallback(callback);
      return;
    }

    var message = _this.onScreenMessages.shift();

    if (message.type === 'info') {
      app.showMessageHtml(message.message, function () {
        _this.doViewOnScreenMessages(callback);
      });
    }

    if (message.type === 'warning') {
      app.showWarningHtml(message.message, function () {
        _this.doViewOnScreenMessages(callback);
      });
    }

    return _this;
  },

  addOnScreenMessage: function addOnScreenMessage(type, message) {
    var _this = this;

    if (isEmpty(message)) {
      return;
    }

    _this.onScreenMessages.push({ type: type, message: message });

    return _this;
  },

  viewOnScreenMessages: function viewOnScreenMessages(callback) {
    var _this = this;

    _this.addOnScreenMessage('info', _this.origData.MessageOnScreen);
    _this.addOnScreenMessage('info', _this.origData.MessageOnScreen2);
    _this.addOnScreenMessage('warning', _this.origData.WarningOnScreen);

    _this.doViewOnScreenMessages(callback);

    return _this;
  },

  //----------------------------------------------------------------------------

  initBasic: function initBasic() {
    var _this = this;

    _this.defaultSetting = {
      showPrintButton: false,
      showAddEan: false,
      showWeigthButton: false,
      showLocationFrom: true,
      showLocationTo: true,
      allowedCheckDisposition: true,
      allowedIncludeAssigned: false,
      allowedChangeLocation: true,
      allowedReleaseItem: false,
      allowedHandlingUnit: false,
      allowedPackage: false,
      allowedRequiredPackage: false,
      allowedLowAmount: true,
      allowedHighAmount: true,
      allowedAutoMismatch: false,
      allowedScanBarcodes: false,
      requiredConfirmHandlingUnit: false,
      requiredConfirmLocation: false,
      requiredConfirmArticle: false,
      requiredInsertAmount: false,
      isLocationScanned: false,
      isArticleScanned: false,
      isBatchChoosen: false,
      isPickingProcess: false,
      isTransferNoteProcess: false,
      isOutgoingControl: false,
      isReceiptProcess: false,
      saveCallBack: null
    };

    _this.confirm = services.get('item-form-confirm');
    _this.locationService = services.get('location-service');
    _this.inputService = services.get('input-service');
    _this.handlingUnitService = services.get('handling-unit-service');
    _this.registerCallbacksBasic();

    return _this;
  }
});
